var render, staticRenderFns
import script from "./CauseBar.vue?vue&type=script&lang=js&"
export * from "./CauseBar.vue?vue&type=script&lang=js&"
import style0 from "./CauseBar.vue?vue&type=style&index=0&id=3f606059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f606059",
  null
  
)

export default component.exports